//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['modelProp', 'parentpage', 'acceptname'],
  data() {
    return {
      orderbtn: false,
    };
  },
  created() {
    this.orderbtn = window.ISWNL;
    // this.homelink = modelProp.homelink+
    // this.$router.push({path:this.modelProp.homelink,query:this.$route.query})
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  watch: {},
  methods: {
    toHome() {
      this.$Glb.baiduCount('首页-更多测试');
      window.location.href = window.location.href.replace(window.location.pathname.split('/')[1], this.modelProp.homelink);
      // this.$router.push({path:this.modelProp.homelink,query:this.$route.query})
      // window.location.href = `${this.modelProp.homelink}${window.location.search}`
    },
  },
};



// WEBPACK FOOTER //
// ./src/plugins/pl_floatmenu/index.vue